import { Stack } from "@chakra-ui/react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import type React from "react"
import { useEffect } from "react"
import { type Item, ItemsService } from "../client"
import Customizer from "../components/Customizer"
import useFrame from "../hooks/useFrame"

interface CustomizerParameters {
  item: string
}

const CustomizerPage: React.FC = () => {
  const { containerRef, sendHeight } = useFrame()
  const itemCode = Route.useSearch({
    select: (search) => search.item ?? "",
  })

  const {
    data: items,
    error,
    isLoading,
  } = useQuery({
    queryFn: () => ItemsService.readItems(),
    queryKey: ["items"],
  })
  useEffect(() => {
    if (!isLoading) {
      sendHeight()
    }
  }, [isLoading, sendHeight])

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error instanceof Error) {
    return <div>Error loading items: {error.message}</div>
  }

  const matchingItem = items?.data.find((item: Item) => item.code === itemCode)

  return (
    <Stack ref={containerRef}>
      {matchingItem ? (
        <Customizer item_code={matchingItem} price={0} />
      ) : (
        <div>No matching item found for code: {itemCode}</div>
      )}
    </Stack>
  )
}

export const Route = createFileRoute("/customize")({
  component: CustomizerPage,
  validateSearch: (search: Record<string, unknown>): CustomizerParameters => {
    return {
      item: (search.item as string) || "",
    }
  },
})

export default CustomizerPage
